import client from "./client";

export const listUnUsedTickets = async () => {
  return await client({
    url: `/tickets?used=false`,
    method: "get",
  });
};

export const listUsedTickets = async (more) => {
  return await client({
    url: `/tickets?used=true&more=${more}`,
    method: "get",
  });
};

export const listMyTickets = async () => {
  return await client({
    url: `/tickets`,
    method: "get",
  });
};

export const cancelTicket = async (data) => {
  return await client({
    url: `/tickets/${data.stockPk}/cancel`,
    method: "post",
    data,
  });
};
